import { ANALYTICS_CONFIG, getFullPageName, getPagedPageName } from './config';
import { setPageInfo, setContentInfo, logDigitalData } from './dataLayer';


export const getFinalPageNameCR = (pageName: string, page: any): string => {
  console.log("INSIDE getFinalPageNameCR: ", pageName, typeof (pageName), page);
  if (!page || typeof page !== 'string') {
    return 'undefined';
  }
  const result = page.substring(0, page.lastIndexOf(':') + 1);
  if (/^\d$/.test(pageName)) {
    return result + ["applicant", "employment", "fee-summary", "submit-success"][+pageName];
  }
  else if (pageName === 'upload-document-summary' || pageName === 'upload-document-details') {
    return result + pageName;
  }
  else if (pageName.includes('manager-portal')) {
    return result + pageName;
  }
  return 'undefined';
};

export const getFinalPageNameTR = (pageName: string, page: any): string => {
  if (!page || typeof page !== 'string') {
    return 'undefined';
  }
  const result = page.substring(0, page.lastIndexOf(':') + 1);
  console.log("INSIDE getFinalPageNameTR: ", pageName, page, result, /^\d$/.test(pageName));
  if (pageName === 'employee' || pageName === 'start' || pageName === 'status-documents' || pageName === 'manager-portal:view-details:applicant' || pageName === 'my-employee-info:employee-info-tab') {
    return page;
  }
  else if (/^\d$/.test(pageName)) {
    return result + ["employee", "employment-info", "primary-approver-info", "school-info", "class-info", "comments", "participants-conditions", "save-submit",][+pageName];
  }
  else if(pageName === 'my-documents-tab' || pageName === 'details-tab' || /^status-documents-\d+$/.test(pageName) || pageName === 'manager-portal' || pageName === 'manager-portal:add-notes' || pageName === 'manager-portal:view-details:employment' || pageName === 'manager-portal:view-details:school' || pageName === 'manager-portal:view-details:class' || pageName === 'manager-portal:view-details:other-apps' || pageName === 'past-apps' ||  /^manager-portal-\d+$/.test(pageName) || pageName === 'my-employee-info:employee-balance-tab'){
    return result + pageName;
  }

  return 'undefined';
}

export const trackCustomPageView = (pageName: string): void => {
  let page, finalPageName = "";
  if (globalThis.window?.digitalData?.page?.pageInfo?.page) {
    page = globalThis.window.digitalData.page.pageInfo?.page;
    console.log("PAGE NAME IN trackCustomPageView: ", page, pageName, page?.substring(0, page.lastIndexOf(':') + 1));
  } else {
    console.log('📄 Page Info not available');
  }
  finalPageName = page?.includes('kporg:en:nat:mykp:wfr:home:tuition:') ? getFinalPageNameTR(pageName, page) : getFinalPageNameCR(pageName, page);
  try {
    if (
      globalThis.window?._satellite?.kpCustomEvent &&
      finalPageName !== "" &&
      finalPageName !== "undefined"
    ) {
      console.log(`📊 ANALYTICS: Custom Page View - ${finalPageName}`);
      globalThis.window._satellite.kpCustomEvent('cjaCustomPageview', {
        pageName: finalPageName,
      });
    } else {
      console.log(`📝 Custom Page View Queued (Adobe _satellite.kpCustomEvent not ready): ${finalPageName}`);
      queueCustomPageView(finalPageName);
    }
  } catch (error) {
    console.error('❌ Error tracking custom page view:', error);
  }
};

//Queue custom page view calls until Adobe _satellite.kpCustomEvent is ready
const customPageViewQueue: string[] = [];

const queueCustomPageView = (pageName: string): void => {
  if (!globalThis.window) {
    console.log(`📝 Window not available (Node.js environment). Custom page view queued: ${pageName}`);
    return;
  }

  customPageViewQueue.push(pageName);
  
  // Retry every 500ms for up to 30 seconds
  const startTime = Date.now();
  const checkInterval = setInterval(() => {
    if (globalThis.window?._satellite?.kpCustomEvent) {
      // _satellite.kpCustomEvent is now available, flush the queue
      console.log(`✅ Adobe _satellite.kpCustomEvent loaded! Flushing ${customPageViewQueue.length} queued custom page views...`);
      while (customPageViewQueue.length > 0) {
        const queuedPageName = customPageViewQueue.shift();
        if (queuedPageName) {
          try {
            globalThis.window._satellite.kpCustomEvent('cjaCustomPageview', {
              pageName: queuedPageName,
            });
            console.log(`✅ Flushed queued custom page view: ${queuedPageName}`);
          } catch (e) {
            console.error(`❌ Error flushing queued custom page view:`, e);
          }
        }
      }
      clearInterval(checkInterval);
    } else if (Date.now() - startTime > 30000) {
      // Stop trying after 30 seconds
      console.warn(`⚠️ Adobe _satellite.kpCustomEvent not loaded after 30s. Clearing queue.`);
      customPageViewQueue.length = 0;
      clearInterval(checkInterval);
    }
  }, 500);
};

/**
 * Fire custom page view
 */
export const trackPageView = (
  pageKey: string,
  pageData?: {
    pageTemplate?: string;
    pageType?: string;
    contentTitle?: string;
    contentType?: string;
    pageNumber?: number;
  }
): void => {
  try {
    // Determine if this is a paginated page
    let pageName: string;
    if (pageData?.pageNumber && pageKey.includes('-N')) {
      pageName = getPagedPageName(pageKey, pageData.pageNumber);
    } else {
      pageName = getFullPageName(pageKey);
    }

    // Update digital data
    setPageInfo(pageName, pageData);
    setContentInfo({
      title: pageData?.contentTitle || pageKey,
      type: pageData?.contentType || 'page',
    });

    // Fire custom page view event (with null check)
    if (typeof window !== 'undefined' && window._satellite) {
      console.log(`🎯 Tracking Page View: ${pageName}`);
      pageName === 'kporg:en:nat:mykp:wfr:home:tuition:employee' && trackCustomPageView('employee');
      window._satellite.track('cjaCustomPageview');
    } else {
      console.log(`📝 Page View Queued (Adobe _satellite not ready): ${pageName}`);
      // Queue the tracking call for when _satellite becomes available
      queueTrackingCall('cjaCustomPageview', pageName);
    }

    logDigitalData();
  } catch (error) {
    console.error('❌ Error tracking page view:', error);
  }
};

/**
 * Queue tracking calls until Adobe _satellite is ready
 */
const trackingQueue: Array<{ eventName: string; pageName: string }> = [];

const queueTrackingCall = (eventName: string, pageName: string): void => {
  if (typeof window === 'undefined') {
    console.log(`📝 Window not available (Node.js environment). Tracking queued: ${pageName}`);
    return;
  }

  trackingQueue.push({ eventName, pageName });
  
  // Retry every 500ms for up to 30 seconds
  const startTime = Date.now();
  const checkInterval = setInterval(() => {
    if (typeof window !== 'undefined' && window._satellite) {
      // _satellite is now available, flush the queue
      console.log(`✅ Adobe _satellite loaded! Flushing ${trackingQueue.length} queued events...`);
      while (trackingQueue.length > 0) {
        const queuedCall = trackingQueue.shift();
        if (queuedCall) {
          try {
            window._satellite.track(queuedCall.eventName);
            console.log(`✅ Flushed queued event: ${queuedCall.pageName}`);
          } catch (e) {
            console.error(`❌ Error flushing queued event:`, e);
          }
        }
      }
      clearInterval(checkInterval);
    } else if (Date.now() - startTime > 30000) {
      // Stop trying after 30 seconds
      console.warn(`⚠️ Adobe _satellite not loaded after 30s. Clearing queue.`);
      trackingQueue.length = 0;
      clearInterval(checkInterval);
    }
  }, 500);
};

/**
 * Track citizenship application steps
 */
export const trackCitizenshipStep = (step: 1 | 2 | 3 | 4): void => {
  const stepMap = {
    1: ANALYTICS_CONFIG.CITIZENSHIP_PAGES.APPLICANT,
    2: ANALYTICS_CONFIG.CITIZENSHIP_PAGES.EMPLOYMENT,
    3: ANALYTICS_CONFIG.CITIZENSHIP_PAGES.FEE_SUMMARY,
    4: ANALYTICS_CONFIG.CITIZENSHIP_PAGES.SUBMIT_SUCCESS,
  };

  trackPageView(stepMap[step], {
    contentTitle: `Citizenship Application - Step ${step}`,
    contentType: 'form',
    pageType: 'application-step',
  });
};

/**
 * Track tuition application steps
 */
export const trackTuitionStep = (step: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8): void => {
  const stepMap = {
    1: ANALYTICS_CONFIG.TUITION_PAGES.EMPLOYEE,
    2: ANALYTICS_CONFIG.TUITION_PAGES.EMPLOYMENT_INFO,
    3: ANALYTICS_CONFIG.TUITION_PAGES.PRIMARY_APPROVER,
    4: ANALYTICS_CONFIG.TUITION_PAGES.SCHOOL_INFO,
    5: ANALYTICS_CONFIG.TUITION_PAGES.CLASS_INFO,
    6: ANALYTICS_CONFIG.TUITION_PAGES.COMMENTS,
    7: ANALYTICS_CONFIG.TUITION_PAGES.PARTICIPANTS_CONDITIONS,
    8: ANALYTICS_CONFIG.TUITION_PAGES.SAVE_SUBMIT,
  };

  trackPageView(stepMap[step], {
    contentTitle: `Tuition Application - Step ${step}`,
    contentType: 'form',
    pageType: 'application-step',
  });
};

/**
 * Track tab selection
 */
export const trackTabSelection = (
  tabName: string,
  pageKey: string
): void => {
  trackPageView(pageKey, {
    contentTitle: `Tab: ${tabName}`,
    contentType: 'tab-selection',
  });
};

/**
 * Track manager portal pagination
 */
export const trackManagerPortalPage = (pageNumber: number, app: 'citizenship' | 'tuition'): void => {
  const basePageKey = app === 'citizenship' 
    ? ANALYTICS_CONFIG.CITIZENSHIP_PAGES.MANAGER_PORTAL_PAGE
    : 'tuition:manager-portal-N';

  trackPageView(basePageKey, {
    pageNumber,
    contentTitle: `Manager Portal - Page ${pageNumber}`,
    contentType: 'pagination',
  });
};

/**
 * Track modal opens
 */
export const trackModalOpen = (modalName: string, pageKey: string): void => {
  trackPageView(pageKey, {
    contentTitle: `Modal: ${modalName}`,
    contentType: 'modal',
  });
};

/**
 * Track error state
 */
export const trackErrorState = (
  errorType: 'date-validation' | 'application-rejected' | 'nuid-not-found',
  errorMessage?: string
): void => {
  const pageKey = `error:${errorType}`;
  
  trackPageView(pageKey, {
    contentTitle: `Error: ${errorType}`,
    contentType: 'error',
  });

  if (errorMessage) {
    console.error(`🚨 Analytics Error: ${errorType} - ${errorMessage}`);
  }
};

/**
 * Home page tracking
 */
export const trackApplicationHome = (app: 'citizenship' | 'tuition'): void => {
  const pageKey = app === 'citizenship' 
    ? ANALYTICS_CONFIG.CITIZENSHIP_PAGES.HOME
    : ANALYTICS_CONFIG.TUITION_PAGES.START;

  trackPageView(pageKey, {
    contentTitle: `${app.charAt(0).toUpperCase() + app.slice(1)} Application Home`,
    contentType: 'home',
  });
};

/**
 * Upload document page tracking
 */
export const trackUploadDocumentPage = (
  app: 'citizenship' | 'tuition',
  section: 'summary' | 'details'
): void => {
  let pageKey: string;
  
  if (app === 'citizenship') {
    if (section === 'summary') {
      pageKey = ANALYTICS_CONFIG.CITIZENSHIP_PAGES.UPLOAD_DOCUMENT_SUMMARY;
    } else {
      pageKey = ANALYTICS_CONFIG.CITIZENSHIP_PAGES.UPLOAD_DOCUMENT_DETAILS;
    }
  } else if (section === 'summary') {
    //check summary or details
    pageKey = ANALYTICS_CONFIG.TUITION_PAGES.STATUS_DOCUMENTS;
  } else {
    pageKey = ANALYTICS_CONFIG.TUITION_PAGES.MY_DOCUMENTS_TAB;
  }

  trackPageView(pageKey, {
    contentTitle: `${app} - Upload Documents (${section})`,
    contentType: 'document-upload',
  });
};